import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const ReportBox = ({ children, title, className, tooltipText, automationId }) => (
  <div className={classnames('c-report-box', className)}>
    <div className="c-report-box__title" data-automation-id={automationId}>
      {title}
      <div className="c-info-tooltip-new u-type--no-transform c-info-tooltip-new-handler u-ml--">
        <div className="c-info-tooltip-new__content u-type--no-transform">
          Up to top 5 {tooltipText}
        </div>
      </div>
    </div>
    {children}
  </div>
);
ReportBox.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  className: PropTypes.string,
  tooltipText: PropTypes.string,
  automationId: PropTypes.string,
};
ReportBox.defaultProps = {
  children: null,
  title: '',
  className: '',
  tooltipText: '',
  automationId: null,
};

export default ReportBox;
